var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageYearn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 124C96.2417 124 124 96.2417 124 62C124 27.7583 96.2417 0 62 0C27.7583 0 0 27.7583 0 62C0 96.2417 27.7583 124 62 124Z",
    fill: "url(#paint0_linear_21597_58800)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4765 55.8965L74.7357 62.5068C75.1056 63.7154 75.2978 64.9835 75.2978 66.2806C75.2978 69.7642 73.915 73.0403 71.4022 75.5039C68.8908 77.9676 65.5501 79.3241 61.9983 79.3241C58.4466 79.3241 55.1058 77.9676 52.5945 75.5039C50.0831 73.0403 48.6989 69.7656 48.6989 66.2806C48.6989 64.9835 48.891 63.7154 49.261 62.5068L42.5202 55.8965C40.8079 58.9825 39.834 62.5213 39.834 66.282C39.834 78.2882 49.758 88.0208 61.9998 88.0208C74.2416 88.0208 84.1656 78.2882 84.1656 66.282C84.1656 62.5213 83.1917 58.9825 81.478 55.8979L81.4765 55.8965Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5511 70.6735H66.4492V56.878L81.596 42.1132L75.3024 35.9821L62.0045 48.9458L48.6965 35.9792L42.4043 42.1103L57.5511 56.8693V70.6735Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21597_58800",
    x1: 62,
    y1: 0,
    x2: 62,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1479F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1360B3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageYearn);
export default __webpack_public_path__ + "static/media/page-yearn.123c235f79c7f20ebbaec6c2cec4c4e3.svg";
export { ForwardRef as ReactComponent };